export default __webpack_public_path__ + "static/media/Notification.28f74dc7.svg";